import * as yup from 'yup';

import { FormParam } from '@repositories/new-application';

import { defaultValues as personalIdentityDefaultValues } from '../personal-identity';
import { defaultValues as familyInformationDefaultValues } from '../family-information';
import { defaultValues as financialDefaultValues } from '../financial';

export const defaultValues: FormParam<'review'> = {
  ...personalIdentityDefaultValues,
  ...familyInformationDefaultValues,
  ...financialDefaultValues,
  privacyPolicy: false,
  validData: false,
};

const schemes: Record<
  keyof Pick<FormParam<'review'>, 'privacyPolicy' | 'validData'>,
  unknown
> = {
  privacyPolicy: yup.bool().oneOf([true], 'Mohon setujui Syarat & Ketentuan'),
  validData: yup.bool().oneOf([true], 'Mohon setujui bahwa data anda valid'),
};

export const reviewSchema =
  yup.object<Pick<FormParam<'review'>, 'privacyPolicy' | 'validData'>>(schemes);
